import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { IonToggle } from '@ionic/angular';
/**
 * Channel Detail Card Component
 * Displays channel details with status toggle and arrow icon for navigation
 */
@Component({
  selector: 'channel-detail-card',
  templateUrl: 'channel-detail-card.html',
  styleUrls: ['channel-detail-card.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChannelDetailCardComponent {
  @Input() optedInDate: string = '--';
  @Input() optedInSource: string = '--';
  @Input() optedOutDate: string = '--';
  @Input() optedOutSource: string = '--';
  @Input() isOptedIn: any;
  @Input() isOffline: boolean = false;
  @Input() isOneKeySearching: boolean = false;
  @Input() isPending: boolean = false;
  @Input() isToggleDisabled: boolean = false;
  @Output() onStatusToggleClick = new EventEmitter<{
    isOptedIn: boolean;
    childRef?: ChannelDetailCardComponent;
  }>();
  @Output() onSignatureClick = new EventEmitter<void>();

  @ViewChild('toggle', { static: true }) toggleRef!: IonToggle;
 
  constructor(
    private readonly cd: ChangeDetectorRef,
  ) {}

  /**
   * Handle status toggle click
   */
  handleStatusToggleClick(event: any) {
    //event.stopPropagation();   
    // Only emit if toggle is clickable
    this.onStatusToggleClick.emit({
      isOptedIn: event,
      childRef: this
    });
  }

  /**
   * Handle arrow icon click
   */
  handleSignatureClick(event: Event) {
    event.stopPropagation();
    // Only allow navigation when opted in
    if (!this.isOptedIn) {
      return;
    }
    this.onSignatureClick.emit();
  }

  /**
   * Revert toggle to a specific value (called by parent if needed)
   */
  revertTo(value: boolean) {
    if (this.toggleRef) {
      this.toggleRef.checked = value;
    }
  }
}

